import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Locale } from '@rd/types';
import { isNotNull } from '@rd/utils/isNotNull';
import { Observable } from 'rxjs';
import { delay, distinctUntilChanged, filter } from 'rxjs/operators';
import { getLocaleSelected } from '../../locale/store/selectors/locale.selectors';
import { CoreState } from '../../store/reducers/index';

@Injectable()
export class LocaleFacade {
  constructor(private store: Store<CoreState>) {}

  selectedLocale$: Observable<Locale> = this.store
    .select(getLocaleSelected)
    .pipe(filter(isNotNull), delay(0), distinctUntilChanged());
}
